import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { contextCompanyIdSelector } from '../../../../redux/context/company/selectors'
import fiscalYearQueryKeys from '../fiscalYearQueryKeys'
import { updateFiscalYear } from '../../service/fiscalYearService'
import { FiscalYear } from '../../../../types/fiscalYear/FiscalYear'
import { showSuccessMessage } from '../../../../utils/message'

export const useCtxUpdateFiscalYear = () => {
  const companyId = useSelector(contextCompanyIdSelector)!
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['updateFiscalYear'],
    mutationFn: (data: Partial<FiscalYear>) => {
      if (data.id === undefined) {
        throw new Error('Fiscal Year ID is required for update')
      }
      if (!companyId) {
        throw new Error('Company ID is required for update')
      }
      return updateFiscalYear(data.id, data, companyId)
    },
    onSuccess: () => {
      showSuccessMessage()
      return queryClient.invalidateQueries({
        queryKey: fiscalYearQueryKeys.list({ companyId })
      })
    }
  })
}
